module.exports = "<div [innerHTML]=\"changelog | safeHtml\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/changelog/changelog.component.html
// module id = 835
// module chunks = 0